import React, {Component} from 'react';
import querySearch from "stringquery";
import {Button, Card, Divider, Header, Image} from "semantic-ui-react";
import {NotValidContent} from "./NotValidContent";

export class PayContainer extends Component {
    constructor(props) {
        super(props);
        const params = querySearch(this.props.location.search);
        params.productName = decodeURI(params.productName)

        let normalized = this.normalizeParams(params);
        //ToDo Add using validation to validate params
        this.state = {valid: this.validate(normalized), payParams: normalized};
    }

    normalizeParams = (params) => {
        return  {
            merchantAccount: params.merchantAccount || params.merchantaccount,
            merchantDomainName: params.merchantDomainName || params.merchantdomainname,
            merchantSignature: params.merchantSignature || params.merchantsignature,
            orderReference: params.orderReference || params.orderreference,
            orderDate: params.orderDate || params.orderdate,
            amount: params.amount,
            currency: params.currency,
            orderTimeout: params.orderTimeout || params.ordertimeout,
            productName: params.productName || params.productname,
            productPrice: params.productPrice || params.productprice,
            productCount: params.productCount || params.productcount,
            serviceUrl: params.serviceUrl || params.serviceurl
        }
    }

    validate = (params) => {
        return this.validateParam(params.merchantAccount)
            && this.validateParam(params.merchantDomainName)
            && this.validateParam(params.merchantSignature)
            && this.validateParam(params.orderReference)
            && this.validateParam(params.orderDate)
            && this.validateParam(params.amount)
            && this.validateParam(params.currency)
            && this.validateParam(params.orderTimeout)
            && this.validateParam(params.productName)
            && this.validateParam(params.productPrice)
            && this.validateParam(params.productCount)
            && this.validateParam(params.serviceUrl)
    };

    validateParam = (param) => {
        return param !== undefined && param !== "";
    };

    pay = (params) => {
        let wayForPay = new window.Wayforpay();
        wayForPay.run({
            merchantAccount: params.merchantAccount,
            merchantDomainName: params.merchantDomainName,
            merchantSignature: params.merchantSignature,
            orderReference: params.orderReference,
            orderDate: params.orderDate,
            amount: params.amount,
            currency: params.currency,
            orderTimeout: params.orderTimeout,
            productName: params.productName,
            productPrice: params.productPrice,
            productCount: params.productCount,
            serviceUrl: params.serviceUrl, 
            language: "UA"
        });
    };

    render() {
        let {orderReference, productName, amount, currency} = this.state.payParams
        let content;

        if (this.state.valid)
            content = <Card.Group centered>
                <Card>
                    <Card.Content>
                        <Card.Header>Замовлення: {orderReference}</Card.Header>
                        {decodeURI(productName)}
                    </Card.Content>
                    <Card.Content extra>
                        {amount + currency}
                    </Card.Content>

                    <Button primary icon='shop' labelPosition='left' content='Оплата'
                            onClick={() => this.pay(this.state.payParams)}/>
                </Card>
            </Card.Group>;
        else
            content = <NotValidContent/>


        return (
            <div>
                <Header as='h1'>
                    <Image src='https://easyms.co/favicon.ico'/>
                    <Header.Content>EasyMS Pay
                        <Header.Subheader>Online reservation payments</Header.Subheader>
                    </Header.Content>
                </Header>

                <Divider/>

                {content}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/PayContainer.js